<template>
  <div class="order-filter-edit is-relative">
    <b-loading :is-full-page="false" :active="loading" />
    <draggable
      v-model="fields"
      draggable=".draggable"
      class="panel"
      @end="onDragEnd"
    >
      <div
        class="panel-block draggable"
        v-for="field in fields"
        :key="field.id"
      >
        <b-checkbox :true-value="1" :false-value="0" v-model="field.visible" />
        {{ field.id }}
      </div>
    </draggable>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import { UserService } from "@/services/user.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  userService: UserService,
  components: {
    Draggable
  },
  data: () => ({
    fieldIds: [
      "status",
      "statusChangeStart",
      "statusChangeEnd",
      "includeVoid",
      "readyToClaim",
      "pendingDateChange",
      "unvettedNotes",
      "starredOrders",
      "pendingClaimApproval",
      "inDispute",
      "currentlyInDispute",
      "textSearch",
      "issuedBy",
      "issuedTo",
      "type",
      "subType",
      "priority",
      "region",
      "problemCode",
      "activityCode",
      "releaseDateStart",
      "releaseDateEnd",
      "dueDatePreset",
      "dueDateStart",
      "dueDateEnd",
      "hasAsset",
      "assetCode",
      "lastModified",
      "managedBy",
      "assignedTo",
      "siteRevisitRequired",
      "claimId",
      "outcomeCode",
      "responsibilityCode",
      "failureCode",
      "repairCode",
      "billingOnHold",
      "bigStorm",
      "furtherWorkRequired",
      "doNotSurvey",
      "escalated",
      "surchargeManhole",
      "hasComments",
      "tags",
      "claimLinesTotal",
      "claimLinesTotalComparison",
      "kpiStart",
      "kpiFinish",
      "kpiAppeal"
    ],
    fields: [],
    loading: false
  }),
  computed: {
    user() {
      return this.$store.state.Auth.user;
    }
  },
  created() {
    this.fields = this.generateFields();
  },
  methods: {
    generateFields() {
      let fields = [];

      if (this.user && this.user.attributes) {
        const attribute = this.user.attributes.find(
          field => field.code === "[SYSTEM][ORDERS]"
        );

        if (attribute) fields = JSON.parse(attribute.value);
      }

      return this.fieldIds.reduce((acc, fieldId, index) => {
        if (!fields.find(field => field.id === fieldId)) {
          acc.push({
            id: fieldId,
            visible: 1,
            order: this.fieldIds.length + index
          });
        }

        return acc;
      }, fields);
    },
    async update() {
      this.loading = true;

      try {
        const user = await this.$options.userService.updateAttribute(
          this.user.id,
          {
            code: "[SYSTEM][ORDERS]",
            value: JSON.stringify(this.fields)
          }
        );

        this.$buefy.toast.open({
          message: "[SYSTEM][ORDERS] has been updated.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {
        console.error(err);
      }

      this.loading = false;
    },
    onDragEnd() {
      // Update order
      this.fields = this.fields.map((field, index) => {
        field.order = index + 1;
        return field;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.draggable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderFilter/OrderFilterEdit.vue